module.exports = __webpack_public_path__ + "static/logo-sbc-10b068163f57ed5ab14a061d3ad185ca.png";